<template>
  <div>
    <div class="time-graph">
      <!-- <div class="big">70</div>
      <div class="medium">20</div>
      <div class="small">10</div> -->
      <div class="medium-graph">
        <canvas id="medium-graph-canvas" width="292" height="292" />
      </div>
      <!-- <div class="big_canvas">
        <canvas id="big-graph-canvas" width="396" height="396" />
      </div>
      <div class="small_canvas">
        <canvas id="small-graph-canvas" width="170" height="170" />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: ['mypercent'],
  components: {},
  data() {
    return {}
  },

  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // if (document.readyState === 'complete') {
    var medium_canvas = document.getElementById('medium-graph-canvas')
    this.drawMain(medium_canvas, 70, 2, '#009AFE00')

    // var big_canvas = document.getElementById('big-graph-canvas')
    // this.drawMain(big_canvas, 90, 1, '#435377')

    // var small_canvas = document.getElementById('small-graph-canvas')
    // this.drawMain(small_canvas, 90, 3, '#435377')
    // }
  },
  methods: {
    drawMain(drawing_elem, percent, colornums, bgcolor) {
      const that = this
      /*
                @drawing_elem: 绘制对象
                @percent：绘制圆环百分比, 范围[0, 100]
                @forecolor: 绘制圆环的前景色，颜色代码
                @bgcolor: 绘制圆环的背景色，颜色代码
            */
      var context = drawing_elem.getContext('2d')
      var center_x = drawing_elem.width / 2
      var center_y = drawing_elem.height / 2
      //   var rad = (Math.PI * 2) / 100
      var speed = 0

      // 绘制背景圆圈
      function backgroundCircle() {
        context.save()
        context.beginPath()
        context.lineWidth = 8 // 设置线宽
        var radius = center_x - context.lineWidth
        context.lineCap = 'round'
        context.strokeStyle = bgcolor
        context.arc(center_x, center_y, radius - 14, 0, Math.PI * 2, false)
        context.stroke()
        context.closePath()
        context.restore()
      }

      // 绘制运动圆环
      function foregroundCircle(n) {
        context.save()
        // context.strokeStyle = forecolor //决定圆环颜色
        context.lineWidth = 25
        context.lineCap = 'round'
        var radius = center_x - context.lineWidth
        context.beginPath()
        var g = context.createLinearGradient(0, 0, 180, 0) // 创建渐变对象  渐变开始点和渐变结束点
        if (colornums == 1) {
          g.addColorStop(0, '#009AFE') // 添加颜色点
          g.addColorStop(1, '#FFB612') // 添加颜色点
          context.strokeStyle = g // 使用渐变对象作为圆环的颜色
        }
        if (colornums == 2) {
          g.addColorStop(0, '#009AFE') // 添加颜色点
          g.addColorStop(1, '#FFB612') // 添加颜色点
          context.strokeStyle = g
        }
        if (colornums == 3) {
          g.addColorStop(0, '#009AFE') // 添加颜色点
          g.addColorStop(1, '#FFB612') // 添加颜色点
          context.strokeStyle = g
        }

        context.arc(
          center_x,
          center_y,
          radius,
          0,
          2 * Math.PI * (n / 100),
          false
        ) // 用于绘制圆弧context.arc(x坐标，y坐标，半径，起始角度，终止角度，顺时针/逆时针)
        context.stroke()
        context.closePath()
        context.restore()
      }

      // 绘制文字
      //   function text() {
      // context.save() // save和restore可以保证样式属性只运用于该段canvas元素
      // context.fillStyle = forecolor
      // var font_size = 40
      // context.font = font_size + 'px Helvetica'
      // var text_width = context.measureText(n.toFixed(0) + '%').width
      // context.fillText(n.toFixed(0) + '%', center_x - text_width / 2, center_y + font_size / 2)
      // context.restore()
      //   }

      // 执行动画
      function drawFrame() {
        if (speed <= percent) {
          window.requestAnimationFrame(drawFrame)
        } else {
          return false
        }
        context.clearRect(0, 0, drawing_elem.width, drawing_elem.height)
        backgroundCircle()
        // text(speed)
        foregroundCircle(that.mypercent)
        if (speed >= percent) {
          speed++
        } else {
          speed += 1
        }
      }
      drawFrame()
    },
  },
}
</script>
<style lang="scss" scoped>
.big {
  position: absolute;
  right: 15px;
  top: 15px;
  width: 27px;
  height: 21px;
  font-size: 27px;
  font-family: Gadugi;
  font-weight: bold;
  color: #0084ff;
}
.medium {
  position: absolute;
  left: 15px;
  top: 15px;
  width: 27px;
  height: 20px;
  font-size: 27px;
  font-family: Gadugi;
  font-weight: bold;
  color: #efa14c;
}
.small {
  position: absolute;
  top: 82px;
  left: 112px;
  width: 26px;
  height: 21px;
  font-size: 27px;
  font-family: Gadugi;
  font-weight: bold;
  color: #ff7c78;
}
.time-graph {
  position: relative;
  width: 128px;
  height: 128px;
  //   width: 258px;
  //   height: 198px;
  transform: rotate(-90deg);
  // background-color: pink;
}

#medium-graph-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 128px;
  height: 128px;
}
#big-graph-canvas {
  position: absolute;
  top: 0;
  left: 30px;
  width: 198px;
  height: 198px;
}
#small-graph-canvas {
  position: absolute;
  top: 56px;
  left: 86px;
  width: 85px;
  height: 85px;
}
</style>
